module.exports = __webpack_public_path__ + "img/on-duty.eab6416a.png";